import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
} from '../styles';
import { Container, Heading } from './ui';
import BlogList from './BlogList';
import Pagination from './Pagination';

const StyledBlogListing = styled.section`
  ${sectionPaddings('30px', '60px')};
  background-color: ${standardColours.white};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const BlogListing = ({
  heading,
  items,
  searchResults,
  totalPageCount,
  listingPage,
  currentPageCount,
}) => (
  <StyledBlogListing>
    <Container>
      <StyledHeading>{heading}</StyledHeading>
      {searchResults !== null ? (
        <BlogList items={searchResults || items} />
      ) : (
        <p>No blog posts match that search criteria</p>
      )}
      {searchResults === undefined && (
        <Pagination
          totalPageCount={totalPageCount}
          listingPage={listingPage}
          currentPageCount={currentPageCount}
        />
      )}
    </Container>
  </StyledBlogListing>
);

export default BlogListing;
